import { Component, Emit, Prop, Vue } from 'vue-property-decorator';
import Modal from '@/assets/common/Modal/Modal.vue';
import { CsvDownload } from "@/types/APIResponse";
import { toCamel } from 'snake-camel';
import store from '@/assets/common/store/store';
import moment from 'moment';

type MappedDataStock = {
    pdId: number| string;
    producerNum: number| string;
    producerName: string;
    picName: string;
    mailAddress: string;
    address: string;
    tel: number| string;
    dateOfBirth: string| Date;
    emailError :boolean;
    pdNumError :boolean;
    dateError:boolean;
    producerNameError:boolean;
    picNameError:boolean;
    addressError:boolean;
    telError: boolean;
    picNameEmptyError: boolean;
    picNameLengthError: boolean;
    producerNameEmptyError: boolean;
    producerNameLengthError: boolean;
    pdNumEmptyError: boolean;
    pdNumNotNumberError: boolean;
    pdNumLengthError:boolean;
    emailEmptyError:boolean;
    telInvalid:boolean;
    authorityError:boolean;
    alreadyInvitedError:boolean;
    sameEmailError:boolean;
    samePdNumError:boolean;
  }

  interface Producer {
  pdId: string;
  mailAddress: string;
  pdnum: string;
  // Add other fields if needed
}

@Component({
    components: {
        Modal
    }
})
export default class ProducerImportModal extends Vue {
    @Prop()
    private value!: boolean

    private csvData: string[][] = [];

    private unMatchedData: string[][] = [];

    private isSpinnerLoading = false;

    private isAlert = false;

    private modalTitle = '生産者のインポート'

    private unmatchedEmails: string[] = [];

    private matchedEmails: string[] = [];

    private isAdmin = false;

    @Prop()
    isShowProducerImportModal!: boolean;

    private mappedResult: MappedDataStock[] = [];
 
    baseUrl = "/producers_list";
    producerBaseUrl ="/producers";
    producerList = [];
    btnDisable = true;


    async save(): Promise<boolean> {

        if (this.matchedEmails.length > 0) {
            const oneWeekLater = new Date();
            oneWeekLater.setDate(oneWeekLater.getDate() + 7);
            oneWeekLater.setHours(23, 59, 59, 0);
    
            const formatDate = (date: Date): string => {
                const pad = (n: number) => n.toString().padStart(2, '0');
                const year = date.getFullYear();
                const month = pad(date.getMonth() + 1);
                const day = pad(date.getDate());
                const hours = pad(date.getHours());
                const minutes = pad(date.getMinutes());
                const seconds = pad(date.getSeconds());
                return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
            };
    
            const expires = formatDate(oneWeekLater);
            const invitationParams = this.matchedEmails.map((email: string) => ({
                mailAddress: email,
                tenantId: this.$store.getters.tenantId,
                expires: expires,
            }));
            const inviteDetailsPostForm = { invitations: invitationParams };
    
            try {
                await this.$apiClient.doRequest("post", `/producer_invite`, inviteDetailsPostForm);
            } catch (err) {
                this.$toasted.error("招待の送信に失敗しました。");
                return false;
            }
        }

        const formatDateToYMD = (date: Date): string => {
            const yyyy = date.getFullYear();
            const mm = String(date.getMonth() + 1).padStart(2, '0');
            const dd = String(date.getDate()).padStart(2, '0');
            return `${yyyy}-${mm}-${dd}`;
        };
       
        const processedProducers = this.mappedResult.map(p => ({
        ...p,
        dateOfBirth: p.dateOfBirth ? formatDateToYMD(new Date(p.dateOfBirth)) : '',
        }));

        const data = { producers: processedProducers};

        if(data.producers.length!=0){
            this.$apiClient.doRequest('put', `${this.producerBaseUrl}/producer_import`, data)
            .then(() => {
               this.$emit('save-success');
               this.$emit("update:isRefresh", true);
               this.$toasted.success('保存しました。')
            })
           this.isAlert = false
           this.clearSelectedFile();
           this.mappedResult = [];
           this.closeModal();
        }else{
            this.$emit('save-success');
        }
        return true
    }

    closeModal() {
        if (this.mappedResult.length>0) {
            const confirm = window.confirm("変更内容を破棄します。よろしいですか？");
            if (confirm) {
                this.$emit("update:isShowProducerImportModal", false);
                this.mappedResult = [];
                this.unmatchedEmails = [];
                this.matchedEmails = [];
                this.$root.$emit('header-inert', false);
            }
        } else {
            this.$root.$emit('header-inert', false);
            this.$emit("update:isShowProducerImportModal", false);
        }
    }

    clearSelectedFile(){
        const fileInput = document.querySelector('.csv-upload-button') as HTMLInputElement | null;
        if (fileInput) {
            fileInput.value = '';
        }
    }

    downloadCSV() {

        this.$apiClient.getRequest(`${this.baseUrl}/csv_export_producers`).then((res: CsvDownload) => {
            this.$apiClient.csvDownload(res);
        })
        .catch((error) => {
            this.$toasted.error("データの取得に失敗しました。");
        })
    }

    uploadCSV(event: Event) {
        const input = event.target as HTMLInputElement;
        const file = input.files?.[0];

        if (file) {
          const reader = new FileReader();
          reader.onload = () => {
            const csvText = reader.result as string;
            this.parseCSV(csvText);
            input.value = '';
          };
          reader.readAsText(file,'Shift_JIS');
        }
    }

   parseCSV(csvText: string) {
    const rows = csvText.trim().split(/\r?\n/);

    this.csvData = rows.flatMap(row => {
        const result: string[] = [];
        let current = '';
        let inQuotes = false;

        for (let i = 0; i < row.length; i++) {
            const char = row[i];
            const next = row[i + 1];

            if (char === '"' && inQuotes && next === '"') {
                current += '"';
                i++; 
            } else if (char === '"') {
                inQuotes = !inQuotes;
            } else if (char === ',' && !inQuotes) {
                result.push(current);
                current = '';
            } else {
                current += char;
            }
        }

        result.push(current);

        const trimmed = result.map(cell => cell.trim());
        const isEmptyRow = trimmed.every(cell => cell === '');

        // Return [] to exclude, or [trimmed] to keep the row
        return isEmptyRow ? [] : [trimmed];
    });

    this.validationCheck();
}

    private async validationCheck() {
        this.mappedResult = this.mapToDesiredFormat(this.csvData);
        this.isSpinnerLoading = true;

         const loginUserRole = this.$store.getters.loginUser.role;
            if (
                loginUserRole.includes("ADMIN") &&
                loginUserRole.includes("CONTRACT_ADMIN")
            ) {
                this.isAdmin = true;
            } else {
                this.isAdmin = false;
            }

            // Count email occurrences
            const emailCountMap: Record<string, number> = {};
            this.mappedResult.forEach(item => {
                const email = (item.mailAddress || '').trim();
                if (email) {
                    emailCountMap[email] = (emailCountMap[email] || 0) + 1;
                }
            });

            const pdNumCountMap: Record<string, number> = {};
                this.mappedResult.forEach(item => {
                    const pdNum = (item.producerNum || '').toString().trim();
                    if (pdNum) {
                        pdNumCountMap[pdNum] = (pdNumCountMap[pdNum] || 0) + 1;
                    }
                });
            await this.$apiClient.doRequest('get', `${this.baseUrl}/producer_details`).then((res) => {
                this.producerList = res.producerList
                this.mappedResult.forEach(mappedItem => {
                const trimmedEmail = (mappedItem.mailAddress || '').trim();
                const trimmedProducerNumber = String(mappedItem.producerNum).trim();


                if (!mappedItem.mailAddress || mappedItem.mailAddress.trim() === '') {
                    mappedItem.emailEmptyError = true;
                    this.btnDisable = true;
                }

                 // Check duplicate email
               mappedItem.sameEmailError = emailCountMap[trimmedEmail] > 1;

               if (pdNumCountMap[trimmedProducerNumber] > 1) {
                    mappedItem.samePdNumError = true;
                } else {
                    mappedItem.samePdNumError = false;
                }

                const matchingProducer = this.producerList.find((producer: any) =>
                    producer.mailAddress === mappedItem.mailAddress
                ) as any;

                if (matchingProducer) {
                    if (matchingProducer.deleteDate || matchingProducer.alert == '招待有効期限を過ぎました。') {
                        this.unmatchedEmails.push(mappedItem.mailAddress);
                    } else if (matchingProducer.inviteDate && !matchingProducer.joinDate && matchingProducer.alert !='招待有効期限を過ぎました。') {
                        mappedItem.alreadyInvitedError = true;
                    } else {
                        mappedItem.pdId = matchingProducer.pdId;
                        mappedItem.emailError = false;
                    }
                } else {
                    this.unmatchedEmails.push(mappedItem.mailAddress);
                }

                 const matchedByPdNum = this.producerList.find(
                (producer: any) => producer.pdNum === mappedItem.producerNum
                )as any;

                if (matchedByPdNum && matchedByPdNum.mailAddress !== mappedItem.mailAddress) {
                    mappedItem.pdNumError = true;
                } 
                else {
                    mappedItem.pdNumError = false;
                }

                const trimmedProducerNum = String(mappedItem.producerNum).trim();
                const isProducerNumInvalid = !trimmedProducerNum || isNaN(Number(trimmedProducerNum)) ||trimmedProducerNum.length > 4;

                mappedItem.pdNumEmptyError = !trimmedProducerNum;
                mappedItem.pdNumNotNumberError = !!trimmedProducerNum && isNaN(Number(trimmedProducerNum));
                mappedItem.pdNumLengthError = trimmedProducerNum.length > 4;

                const trimmedProducerName = String(mappedItem.producerName).trim();
                mappedItem.producerNameError = !trimmedProducerName || trimmedProducerName.length > 100;

                mappedItem.producerNameEmptyError = !trimmedProducerName;
                mappedItem.producerNameLengthError = trimmedProducerName.length > 100;

                const trimmedPicName = String(mappedItem.picName).trim();
                mappedItem.picNameError = !trimmedPicName || trimmedPicName.length > 255;

                mappedItem.picNameEmptyError = !trimmedPicName;
                mappedItem.picNameLengthError = trimmedPicName.length > 255;

                const trimmedAddress = String(mappedItem.address).trim();
                mappedItem.addressError =  trimmedAddress.length > 200;

                const trimmedTel = String(mappedItem.tel).trim();
                mappedItem.telError =  trimmedTel.length > 15;
                const isInvalidTel = /[^0-9+-]/.test(trimmedTel)
                mappedItem.telInvalid = isInvalidTel;

            });
            if (this.unmatchedEmails.length > 0) {
                if (this.isAdmin) {
                const query = this.unmatchedEmails.map(email => `emails=${encodeURIComponent(email)}`).join('&');
                this.$apiClient.doRequest('get', `${this.producerBaseUrl}/check_emails?${query}`)
                .then((res) => {
                    this.matchedEmails = res;
                    const trulyUnmatchedEmails = this.unmatchedEmails.filter(email => !this.matchedEmails.includes(email));
                    this.mappedResult.forEach(mappedItem => {
                        if (trulyUnmatchedEmails.includes(mappedItem.mailAddress)) {
                          mappedItem.emailError = true;
                        }
                    });
                });
            }else {
            this.mappedResult.forEach(mappedItem => {
                if (this.unmatchedEmails.includes(mappedItem.mailAddress)) {
                    mappedItem.authorityError  = true;
                }
            });
        }
        
        }
            this.btnDisable = this.mappedResult.some(
                item => item.dateError || item.emailError || item.emailEmptyError || item.pdNumError || item.producerNameError || item.picNameError || item.addressError || item.telError || item.pdNumNotNumberError||item.pdNumLengthError || item.pdNumEmptyError || item.telInvalid || item.authorityError || item.alreadyInvitedError || item.sameEmailError || item.samePdNumError
            );
        });
    }
    
    private mapToDesiredFormat(data: string[][]): MappedDataStock[] {
        const mappedData: MappedDataStock[] = [];
        const isValidDate = (dateString: string): boolean => {
            const datePattern = /^(\d{4}[-/]\d{1,2}[-/]\d{1,2}|\d{8})$/;
            if (!datePattern.test(dateString)) return false;
    
            let year, month, day;
            if (dateString.includes('-') || dateString.includes('/')) {
                const parts = dateString.split(/[-/]/);
                year = parseInt(parts[0], 10);
                month = parseInt(parts[1], 10);
                day = parseInt(parts[2], 10);
            } else {
                year = parseInt(dateString.slice(0, 4), 10);
                month = parseInt(dateString.slice(4, 6), 10);
                day = parseInt(dateString.slice(6, 8), 10);
            }
    
            const dateObj = new Date(year, month - 1, day);
            return (
                dateObj.getFullYear() === year &&
                dateObj.getMonth() === month - 1 &&
                dateObj.getDate() === day
            );
        };
        for (const row of data.slice(1)) {
            const [producerNum, producerName, picName, mailAddress, address, tel, dateOfBirth] = row;
            
            // Call the halfWidthConvertion function for each element in the row
            const convertedRow = row.map(item => this.halfWidthConvertion(item));
        
            const [convertedProducerNum, convertedProducerName, convertedPicName, convertedMailAddress, convertedAddress, convertedTel, convertedDateOfBirth] = convertedRow;
        
            let producerDateErrorFlag = false;
            let formattedDateOfBirth = convertedDateOfBirth; // default to original
            if (convertedDateOfBirth && convertedDateOfBirth.trim() !== '') {
             producerDateErrorFlag = !isValidDate(convertedDateOfBirth);

                if (!producerDateErrorFlag) {
                let year, month, day;
                if (convertedDateOfBirth.includes('-') || convertedDateOfBirth.includes('/')) {
                    const parts = convertedDateOfBirth.split(/[-/]/);
                    year = parts[0];
                    month = parts[1].padStart(2, '0');
                    day = parts[2].padStart(2, '0');
                } else {
                    year = convertedDateOfBirth.slice(0, 4);
                    month = convertedDateOfBirth.slice(4, 6);
                    day = convertedDateOfBirth.slice(6, 8);
                }

                formattedDateOfBirth = `${year}/${month}/${day}`;
            }
        }
        
            const mappedEntry: MappedDataStock = {
                pdId: '',
                producerNum:  convertedProducerNum,
                producerName: convertedProducerName,
                picName: convertedPicName,
                mailAddress: convertedMailAddress,
                address: convertedAddress,
                tel: convertedTel,
                dateOfBirth: formattedDateOfBirth,
                emailError:false,    
                pdNumError:false,
                dateError:producerDateErrorFlag,
                producerNameError: false,
                picNameError:false,
                addressError:false,
                telError:false,
                picNameEmptyError: false,
                picNameLengthError: false,
                producerNameEmptyError: false,
                producerNameLengthError: false,
                pdNumEmptyError: false,
                pdNumNotNumberError: false,
                pdNumLengthError:false,
                emailEmptyError:false,
                telInvalid: false,
                authorityError:false,
                alreadyInvitedError:false,
                sameEmailError:false,
                samePdNumError:false,
            };
            mappedData.push(mappedEntry);
        }        
        return mappedData;
    }
    
    private halfWidthConvertion(inputString: string): string {
        return inputString
            .split('')
            .map(char => {
                const code = char.charCodeAt(0);
                if (code >= 65281 && code <= 65374) {
                    return String.fromCharCode(code - 65248);
                }
                return char;
            })
        .join('');
    }
 }
